// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d7e8a7fc","453":"2d205f7a"}[chunkId] + ".chunk.js";
};